/*
 * @Author: yzr
 * @Date: 2021-07-19 11:30:43
 * @Last Modified by: yzr
 * @Last Modified time: 2021-07-20 15:26:02
 */
import WarehousingOverview from './warehousing_overview.vue';

export default WarehousingOverview;
